import meat1 from '../assets/images/products/meat/meat1.png'
import meat2 from '../assets/images/products/meat/meat2.png'
import meat3 from '../assets/images/products/meat/meat3.png'
import meat4 from '../assets/images/products/meat/meat4.png'
import meat5 from '../assets/images/products/meat/meat5.png'
import meat6 from '../assets/images/products/meat/meat6.png'

export const meatProductsList =
[
    {
        cat:'meat',
        products:[
            {
                image: meat1,
                subtitle: 'frozen meat',
                title: 'Meat Cuts',
                rating: 4.9
            },
            {
                image: meat2,
                subtitle: 'frozen meat',
                title: 'Meat Rack',
                rating: 4.9
            },
            {
                image: meat3,
                subtitle: 'frozen meat',
                title: 'Meat Chops',
                rating: 4.2
            },
            {
                image: meat4,
                subtitle: 'frozen meat',
                title: 'Leg meat',
                rating: 4.7
            },
            {
                image: meat5,
                subtitle: 'frozen meat',
                title: 'Lamp Meat',
                rating: 4.9
            },
            {
                image: meat6,
                subtitle: 'frozen meat',
                title: 'Meat Ribs',
                rating: 4.9
            },
        ]
    }
    
]
